import { useEffect, type JSX } from 'react';
import { RouterProvider } from '@tanstack/react-router';

import { AuthBoundary } from './components/AuthBoundary';
import { router } from './router';
import { initWebSocketClient } from './api/ws';

/**
 * Top-level application shell.
 *
 * Responsibilities:
 * - Mount the TanStack router.
 * - Gate rendering behind the auth boundary (redirects to /login
 *   when a protected route is hit without a token — Wave 2 will
 *   attach actual login flows; right now the boundary simply
 *   hydrates the persisted token and exposes a signed-out state).
 * - Open the multiplexed WebSocket client once per session so that
 *   realtime stores stay hot.
 */
export function App(): JSX.Element {
  useEffect(() => {
    const client = initWebSocketClient();
    return () => {
      client.disconnect();
    };
  }, []);

  return (
    <AuthBoundary>
      <RouterProvider router={router} />
    </AuthBoundary>
  );
}
